/**
 * La tessera con l'icona della sezione, accanto al titolo della pagina (26/10/2026).
 * È la stessa icona della barra laterale: dice a colpo d'occhio dove si è,
 * senza leggere il titolo. Clay come i bottoni, mai colorata.
 *   <SectionMark icon="repeat" />            icona Lucide della sezione
 *   <SectionMark brand="godeal" name="GoDeal" />   un marchio al posto dell'icona
 */
import { Icon, type IconName } from './Icon';
import { BrandLogo } from './BrandLogo';
import { cn } from '../../lib/utils';
import './brand.css';

interface SectionMarkProps {
  icon?: IconName;
  brand?: string;
  name?: string;
  size?: number;
  className?: string;
}

export function SectionMark({ icon, brand, name, size = 48, className }: SectionMarkProps) {
  if (brand) return <BrandLogo brand={brand} name={name ?? brand} size={size} className={className} />;
  return (
    <span className={cn('section-mark', className)} style={{ width: size, height: size, borderRadius: Math.round(size * 0.29) }} aria-hidden>
      {icon && <Icon name={icon} size={Math.round(size * 0.42)} />}
    </span>
  );
}
